<!-- Loader-->
<div class="div-window_maps_title" *ngIf="!isLoaded">
  <div class="h3 loaderH3">Add-ons</div>
  <div id="loadingText" class="h5">Loading...</div>
</div>

<div
  class="div-window_maps_title"
  *ngIf="(isLoaded && !data) || (!userHaveAccess && isLoaded)"
>
  <div class="h3 loaderH3">Add-ons</div>
  <div id="your-add-ons" class="test_no_addOns" style="color: 555555 !important">
    <p>You currently have no Add-ons.</p>
  </div>
</div>

<form id="subscription-removal" *ngIf="isLoaded && data">
  <!-- AddOns Main Div -->
  <div
    *ngIf="userHaveAccess"
    id="your-sub-addons"
    class="hide_forms div-window_maps"
    style="display: block"
  >
    <!-- Add Ons Heading and Edit Button -->
    <div class="h3 h3Add" *ngIf="userHaveAccess">
      Add-ons
      <button
        *ngIf="!isEdit"
        (click)="edit()"
        type="button"
        class="text-btn show-subscription-items-addons"
      >
        Edit
      </button>
    </div>
    <!-- Collaboration and Ads Ons Div -->
    <div id="your-add-ons" *ngIf="userHaveAccess">
      <!-- Available seats and edit option-->
      <ng-container *ngIf="data && userHaveAccess">
        <ng-container *ngFor="let collab of collaborators; index as i">
          <div
            *ngIf="collab.current >= '0' && collab.status !== 'canceled'"
            style="text-align: center; display: inline-block; width: 100%"
          >
            <div
              id="addons"
              class="add-ons-div addDiv"
              style="font-size: 18px; display: inline; float: left"
            >
              Collaborator Seats
            </div>
            <div
              class="add-ons-div show-subscription-items-addons"
              *ngIf="!isEdit && collab.status !== 'canceled'"
            >
              Quantity {{ collab.quantity }}
            </div>
            <div
              class="add-ons-div add-ons-div1"
              *ngIf="isEdit && collab.status !== 'canceled'"
            >
              Quantity
            </div>
            <div
              *ngIf="isEdit && collab.status !== 'canceled'"
              id="seats"
              style="display: inline; border: solid 1px grey; padding: 1px"
            >
              <input
                *ngIf="collab.status !== 'canceled'"
                type="text"
                readonly=""
                name="seats"
                id="seats"
                style="width: 30px; text-align: center; border: none"
                seat-name="2"
                class="add-ons-div"
                [value]="changeValue[i]"
              />
              <div id="acc-seats">
                <img
                  *ngIf="collab.status !== 'canceled'"
                  src="/assets/img/arrow-up.png"
                  class="up"
                  (click)="increaseValue(changeValue, i)"
                />
                <img
                  *ngIf="collab.status !== 'canceled'"
                  src="/assets/img/arrow-down.png"
                  class="down"
                  (click)="decreaseValue(changeValue, i)"
                />
              </div>
            </div>
            <div
              *ngIf="collab.status !== 'canceled'"
              class="add-ons-div"
              style="float: right"
            >
              {{ collab.plans }}
            </div>
            <br *ngIf="!isEdit" /><br *ngIf="!isEdit" />
            <div id="cancel-seats"></div>
          </div>
          <!-- Unsub seats without edit option -->
          <div
            *ngIf="collab.cancel_seat > '0' || collab.status === 'canceled'"
            style="text-align: center; display: inline-block; width: 100%"
            class="unsub_collab"
          >
            <div
              id="addons"
              class="add-ons-div"
              style="font-size: 18px; display: inline; float: left"
            >
              Collaborator Seats
            </div>
            <div
              *ngIf="collab.current > '0' && collab.status === 'canceled'"
              class="add-ons-div show-subscription-items-addons"
            >
              Quantity {{ collab.current }}
            </div>
            <!-- <div *ngIf="collab.current > '0'&&collab.status==='canceled'" class="add-ons-div show-subscription-items-addons">
            Quantity {{ collab.current }}
          </div> -->
            <div
              *ngIf="collab.status !== 'canceled' && collab.cancel_seat > '0'"
              class="add-ons-div show-subscription-items-addons"
            >
              Quantity {{ collab.cancel_seat }}
            </div>
            <div class="add-ons-div" style="float: right">
              {{ collab.plans }}*
            </div>
            <!-- <br /><br /> -->
            <div id="cancel-seats"></div>
          </div>
        </ng-container>
      </ng-container>

      <!-- Outreach and edit option-->
      <div
        *ngIf="outReach && userHaveAccess"
        style="text-align: center; display: inline-block; width: 100%"
        [ngStyle]="isEdit && { 'margin-top': '2px' }"
      >
        <div
          id="addons"
          class="add-ons-div"
          style="font-size: 18px; display: inline; float: left"
        >
          Outreach
        </div>
        <div
          *ngIf="
            isEdit &&
            outReach.status !== 'canceled' &&
            outReach.status !== 'expired'
          "
          class="hide-subscription-items-addons hide-subscription-items-addons1"
        >
          <div class="add-ons-div add-ons-div1">End</div>
          <input
            (change)="onChange($event)"
            type="checkbox"
            plan-name="Outreach"
            [value]="outReach.plan_code"
            class="subscription-remove-addons subscription-remove add-ons-div"
            name="subscription-remove"
            [checked]="endCheck"
          />
        </div>
        <div
          class="add-ons-div"
          style="float: right"
          *ngIf="
            outReach.status === 'canceled' || outReach.status === 'expired'
          "
        >
          {{ outReach.plans }}*
        </div>
        <div
          class="add-ons-div"
          style="float: right"
          *ngIf="
            outReach.status !== 'canceled' && outReach.status !== 'expired'
          "
        >
          {{ outReach.plans }}
        </div>
        <br /><br />
        <div id="cancel-seats"></div>
      </div>
    </div>

    <!-- Back and Submit Button -->
    <div style="text-align: right" *ngIf="isEdit">
      <div class="hide-subscription-items-addons">
        <button
          type="button"
          id="cancel-payment-addons"
          (click)="back()"
          class="btn gernal-btn"
        >
          Back
        </button>
        <button
          type="button"
          id="update-subscription"
          class="btn gernal-btn recurring-update"
          (click)="submit($event)"
        >
          Submit
        </button>
      </div>
    </div>
    <!-- Access Continue Div -->
    <div
      id="cancel-sub-addons"
      style="text-align: right"
      *ngIf="showAccessMessage"
    >
      <p style="margin-top: 15px !important">
        *Access continues through end of billing cycle
      </p>
    </div>
  </div>
</form>

<!-- text rendering from backend api -->
<div
  id="addons-dashboard-text"
  class="dashboard-map-text"
  *ngIf="isLoaded && text"
>
  <div>
    <div [innerHtml]="text | sanitizeHtml" id="innerTextDiv"></div>
  </div>
</div>
